(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5082],{

/***/ 37304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ getAgents; }
});

// UNUSED EXPORTS: getAgent

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/agent.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AgentStatic;

(function (AgentStatic) {
  AgentStatic["AgenciesList"] = "/v2/agents";
})(AgentStatic || (AgentStatic = {}));

var AgentDynamic = {
  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description get Agent details
   */
  AgentDetail: function AgentDetail(AgentID) {
    return "/v2/agents/".concat(AgentID);
  }
};
var agent_endpoint_AgentEndpoints = _objectSpread(_objectSpread({}, AgentDynamic), AgentStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/agent.request.ts


var getAgents = function getAgents(filters) {
  return (0,base_services_request/* getRequest */.A_)(agent_endpoint_AgentEndpoints.AgenciesList, filters).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
};
var getAgent = function getAgent(id) {
  return getRequest(AgentEndpoints.AgentDetail(id)).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  })["catch"](function (error) {
    return error.response;
  });
};

/***/ }),

/***/ 11882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v2": function() { return /* binding */ baseURL; },
  "Jl": function() { return /* binding */ deleteRequest; },
  "A_": function() { return /* binding */ getRequest; },
  "Ft": function() { return /* binding */ patchResquest; },
  "j0": function() { return /* binding */ postRequest; }
});

// UNUSED EXPORTS: apiClient, getFileRequest, putRequest

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./shared/models/functions/create-formdata.helper.ts
function createFormData(jsonObject, parentKey, carryFormData) {
  var formData = carryFormData || new FormData();
  var index = 0;

  for (var _key in jsonObject) {
    if (Object.prototype.hasOwnProperty.call(jsonObject, _key)) {
      if (jsonObject[_key] !== null && jsonObject[_key] !== undefined) {
        var propName = parentKey || _key;

        if (parentKey && _isObject(jsonObject)) {
          propName = parentKey + "[".concat(_key, "]");
        }

        if (parentKey && Array.isArray(jsonObject)) {
          propName = parentKey + "[".concat(index, "]");
        }

        if (jsonObject[_key] instanceof File) {
          formData.append(propName, jsonObject[_key]);
        } else if (jsonObject[_key] instanceof FileList) {
          for (var j = 0; j < jsonObject[_key].length; j++) {
            formData.append(propName + "[".concat(j, "]"), jsonObject[_key].item(j));
          }
        } else if (Array.isArray(jsonObject[_key]) || _isObject(jsonObject[_key])) {
          createFormData(jsonObject[_key], propName, formData);
        } else if (typeof jsonObject[_key] === "boolean") {
          formData.append(propName, +jsonObject[_key] ? "1" : "0");
        } else {
          formData.append(propName, jsonObject[_key]);
        }
      }

      index++;
    }
  }

  return formData;
}

function _isObject(val) {
  return !Array.isArray(val) && typeof val === "object" && !!val;
}
// EXTERNAL MODULE: ./shared/services/auth.service.ts
var auth_service = __webpack_require__(84100);
;// CONCATENATED MODULE: ./api/base-services.request.ts




var baseURL = "https://api.remaxrd.com";
var apiKey = "95ac554a9df925bdc63c8b34d43ed5a162770c3630a0543ce7b4880d56c2778619abe5c8ad2cf9647099cfab0cd10112c4133cbc8521cedb14ae5f57fcd32a42$2" + "$2";
var apiClient = axios_default().create({
  baseURL: baseURL,
  headers: {
    "Content-type": "application/json",
    "access-control-allow-origin": "*",
    "x-api-key": apiKey,
    "x-requested-with": "XMLHttpRequest"
  },
  paramsSerializer: function paramsSerializer(params) {
    return lib_default().stringify(params, {
      encode: false
    });
  }
});
var getRequest = function getRequest(endPoint, filters) {
  var headers = getAuthHeader();
  return apiClient.get("".concat(endPoint), {
    params: filters,
    headers: headers
  });
};
var postRequest = function postRequest(endPoint, body, useFormData) {
  var formBody = body;
  var headers = getAuthHeader();
  if (useFormData) formBody = createFormData(body);
  return apiClient.post("".concat(endPoint), formBody, {
    headers: headers
  });
};
var putRequest = function putRequest(endPoint, body) {
  return apiClient.post("".concat(endPoint), body);
};
var deleteRequest = function deleteRequest(endPoint) {
  var headers = getAuthHeader();
  return apiClient["delete"](endPoint, {
    headers: headers
  });
};
var getFileRequest = function getFileRequest(endPoint) {
  return apiClient.get("".concat(endPoint), {
    responseType: "blob"
  });
};
var patchResquest = function patchResquest(endPoint, body) {
  var headers = getAuthHeader();
  return apiClient.patch(endPoint, body, {
    headers: headers
  });
};

function getAuthHeader() {
  var token = (0,auth_service/* getUserToken */.N)();
  return token ? {
    Authorization: "Bearer " + token
  } : undefined;
}

/***/ }),

/***/ 65198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function useDataLayerEvent() {
  var event = function event(info) {
    var Widows = window;

    if (typeof Widows.dataLayer != 'undefined' && typeof Widows != 'undefined') {
      Widows.dataLayer.push(_objectSpread({
        event: info.event_name
      }, info));
      console.log("dataLayer event", info);
    }
  };

  return {
    event: event
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useDataLayerEvent);

/***/ }),

/***/ 44231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90116);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61730);



function useWidth() {
  var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();

  var keys = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(theme.breakpoints.keys).reverse();

  return keys.reduce(function (output, key) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var matches = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(theme.breakpoints.up(key));
    return !output && matches ? key : output;
  }, null) || "xs";
}

/***/ }),

/***/ 2505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ List_section; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__(246);
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);
// EXTERNAL MODULE: ./custom-hooks/use-width.hook.ts
var use_width_hook = __webpack_require__(44231);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./shared/models/const/placeholder-images.const.ts
var placeholder_images_const = __webpack_require__(72020);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ContactPhoneOutlined.js
var ContactPhoneOutlined = __webpack_require__(35756);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PermPhoneMsgOutlined.js
var PermPhoneMsgOutlined = __webpack_require__(48962);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AttachEmailOutlined.js
var AttachEmailOutlined = __webpack_require__(50944);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AccountCircleOutlined.js
var AccountCircleOutlined = __webpack_require__(69436);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocationOnOutlined.js
var LocationOnOutlined = __webpack_require__(874);
// EXTERNAL MODULE: ./custom-hooks/data-layer-event.hook.ts
var data_layer_event_hook = __webpack_require__(65198);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/agency-card/index.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















var AgencyCard = function AgencyCard(props) {
  var _props$brokers, _props$brokers2, _props$logo, _props$phone, _props$address$toLowe, _props$address, _props$email$toLowerC, _props$email;

  var width = (0,use_width_hook/* useWidth */.z)();
  var mobile = ["xs", "sm"].includes(width);
  var name = props.name,
      id = props.id;
  var translation = (0,next_intl_cjs_production_min.useTranslations)("listAgentAgency.list");
  var brokersContent = (props.brokers || []).slice(0, 3).map(function (b) {
    return b.broker_name;
  }).join(", ") + (props.brokers.length > 3 ? "..." : "");
  var brokersPhone = (props.brokers || []).slice(0, 3).map(function (b) {
    return b.broker_phone;
  });
  var broker = props === null || props === void 0 ? void 0 : (_props$brokers = props.brokers) === null || _props$brokers === void 0 ? void 0 : _props$brokers.map(function (x) {
    var _x$broker_name;

    return (_x$broker_name = x.broker_name) !== null && _x$broker_name !== void 0 ? _x$broker_name : "";
  }).toString();
  var phone = props === null || props === void 0 ? void 0 : (_props$brokers2 = props.brokers) === null || _props$brokers2 === void 0 ? void 0 : _props$brokers2.map(function (x) {
    var _x$broker_phone;

    return (_x$broker_phone = x.broker_phone) !== null && _x$broker_phone !== void 0 ? _x$broker_phone : "";
  });
  var detailRoute = pages_path/* CPagesPath.es.agency_detail */.K.es.agency_detail({
    name: name.replace("RE/MAX", "RE-MAX"),
    id: id
  }) + "?areferer=" + id; // if (name.includes("Utopia") || name.includes("utopia")) {
  //   detailRoute =
  //     CPagesPath.es.agency_detail({
  //       name: "re-max-utopia",
  //       id: 23,
  //     }) +
  //     "?areferer=" +
  //     id;
  //   broker = "James Rollins";
  //   phone = ["(829) 629-0962"];
  // }

  var formatPhoneNumber = function formatPhoneNumber(phoneNumber) {
    var formattedPhoneNumber = "(".concat(phoneNumber.slice(0, 3), ") ").concat(phoneNumber.slice(3, 6), "-").concat(phoneNumber.slice(6));
    return formattedPhoneNumber;
  };

  var _useDataLayerEvent = (0,data_layer_event_hook/* default */.Z)(),
      event = _useDataLayerEvent.event;

  var handleClickMobile = function handleClickMobile(phone) {
    window.open("tel:".concat(phone));
    event({
      event_name: "agency_card_phone",
      body: {
        name_agency: props.name,
        phone_agency: phone || props.phone,
        url: detailRoute,
        id_agency: props.id
      }
    });
  };

  var handleClickEmail = function handleClickEmail() {
    window.open("mailto:".concat(props.email));
    event({
      event_name: "agency_card_email",
      body: {
        name_agency: props.name,
        email_agency: props.email,
        url: detailRoute,
        id_agency: props.id
      }
    });
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(ContentCard, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ImageContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AgencyImage, {
    src: (_props$logo = props.logo) !== null && _props$logo !== void 0 ? _props$logo : placeholder_images_const/* AgencyPicPlaceholder */.bV,
    alt: "Logo ".concat(props.name)
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(InfoContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardsInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(IconContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PermPhoneMsgOutlined/* default */.Z, {
    sx: {
      color: "#ffff",
      fontSize: "1rem"
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(LineInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardItemLabel, null, translation("phone")), (0,emotion_react_browser_esm/* jsx */.tZ)(CardItemInfoRef, {
    onClick: function onClick() {
      return handleClickMobile(props.phone);
    }
  }, formatPhoneNumber((_props$phone = props.phone) !== null && _props$phone !== void 0 ? _props$phone : "-")))), (0,emotion_react_browser_esm/* jsx */.tZ)(CardsInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(IconContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AccountCircleOutlined/* default */.Z, {
    sx: {
      color: "#ffff",
      fontSize: "1rem"
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(LineInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardItemLabel, null, translation("broker")), (0,emotion_react_browser_esm/* jsx */.tZ)(CardItemInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(TextBrokers, null, brokersContent.toLowerCase())))), (0,emotion_react_browser_esm/* jsx */.tZ)(CardsInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(IconContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContactPhoneOutlined/* default */.Z, {
    sx: {
      color: "#ffff",
      fontSize: "1rem"
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(LineInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardItemLabel, null, translation("brokersPhone")), (props.brokers || []).slice(0, 2).map(function (broker, index) {
    var _broker$broker_phone;

    return (0,emotion_react_browser_esm/* jsx */.tZ)(CardItemInfoRef, {
      key: index,
      onClick: function onClick() {
        return handleClickMobile(broker.broker_phone);
      }
    }, formatPhoneNumber(((_broker$broker_phone = broker.broker_phone) === null || _broker$broker_phone === void 0 ? void 0 : _broker$broker_phone.toLowerCase()) || "-"));
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(CardsInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(IconContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(LocationOnOutlined/* default */.Z, {
    sx: {
      color: "#ffff",
      fontSize: "1rem"
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(LineInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardItemLabel, null, translation("address")), (0,emotion_react_browser_esm/* jsx */.tZ)(CardItemInfo, null, (_props$address$toLowe = (_props$address = props.address) === null || _props$address === void 0 ? void 0 : _props$address.toLowerCase()) !== null && _props$address$toLowe !== void 0 ? _props$address$toLowe : "-"))), (0,emotion_react_browser_esm/* jsx */.tZ)(CardsInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(IconContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AttachEmailOutlined/* default */.Z, {
    sx: {
      color: "#ffff",
      fontSize: "1rem"
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(LineInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardItemLabel, null, translation("email")), (0,emotion_react_browser_esm/* jsx */.tZ)(CardItemInfoRef, {
    onClick: handleClickEmail
  }, (_props$email$toLowerC = (_props$email = props.email) === null || _props$email === void 0 ? void 0 : _props$email.toLowerCase()) !== null && _props$email$toLowerC !== void 0 ? _props$email$toLowerC : "-")))), (0,emotion_react_browser_esm/* jsx */.tZ)(CardContentButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: detailRoute,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(CardButtonBlue, null, translation("seeDetails")))));
};

/* harmony default export */ var agency_card = (AgencyCard);

var IconContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ybm5lc12"
} : 0)( true ? {
  name: "gtvr7i",
  styles: "padding:0.4rem;border-radius:50%;display:flex;background-color:var(--color-brand-blue-secondary)"
} : 0);

var ContentCard = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ybm5lc11"
} : 0)( true ? {
  name: "is07e7",
  styles: "display:flex;padding:1.85rem;border-radius:14px;height:630px;background-color:var(--color-brand-cream-primary);flex-direction:column;@media screen and (max-width: 480px){height:640px;}"
} : 0);

var InfoContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ybm5lc10"
} : 0)( true ? {
  name: "tbt81d",
  styles: "padding:1.2rem 1.4rem 2.2rem 1.8rem;border-radius:1.8rem;overflow-wrap:anywhere;align-items:flex-start;background-color:rgb(252, 252, 252);margin:1.2rem 0;height:auto;overflow:hidden"
} : 0);

var LineInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ybm5lc9"
} : 0)( true ? {
  name: "98sly3",
  styles: "display:flex;flex-direction:column;gap:0.1rem"
} : 0);

var ImageContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ybm5lc8"
} : 0)( true ? {
  name: "1xkddao",
  styles: "display:flex;align-self:center;justify-content:center;overflow:hidden;@media screen and (max-width: 480px){margin-bottom:10px;}"
} : 0);

var AgencyImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1ybm5lc7"
} : 0)( true ? {
  name: "1g7mqxx",
  styles: "border-top-left-radius:1rem;border-top-right-radius:1rem;object-fit:contain;width:100%;height:9rem;@media screen and (max-width: 480px){width:100%;max-width:200px;}"
} : 0);

var TextBrokers = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1ybm5lc6"
} : 0)("display:-webkit-box;-webkit-line-clamp:", function (_ref) {
  var lines = _ref.lines;
  return lines || "";
}, ";-webkit-box-orient:vertical;overflow:hidden;vertical-align:middle;line-height:19px;" + ( true ? "" : 0));

var CardContentButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ybm5lc5"
} : 0)( true ? {
  name: "14tjlji",
  styles: "display:flex;justify-content:center;width:100%;margin-top:auto"
} : 0);

var CardButtonBlue = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1ybm5lc4"
} : 0)( true ? {
  name: "o4pf6a",
  styles: "padding:0.7rem 2rem;border-radius:5rem;color:#fff;font-size:var(--fs-body-small);font-weight:700;align-items:center;border:none;justify-content:center;display:flex;background:black;cursor:pointer;:hover{background:black;}"
} : 0);

var CardsInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ybm5lc3"
} : 0)( true ? {
  name: "1lci486",
  styles: "display:flex;align-items:flex-start;margin-bottom:1rem;gap:0.5rem;a{font-weight:400!important;font-size:0.835rem;color:var(--color-brand-blue-main)!important;}"
} : 0);

var infoShareStyles =  true ? {
  name: "1s1yazo",
  styles: "font-size:0.7rem;color:black!important;text-transform:capitalize!important"
} : 0;

var CardItemLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1ybm5lc2"
} : 0)("margin-bottom:0.1rem;", infoShareStyles, " font-weight:700;font-size:0.75rem;&::after{content:\":\";}" + ( true ? "" : 0));

var CardItemInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1ybm5lc1"
} : 0)(infoShareStyles, " font-weight:400;font-size:0.835rem;" + ( true ? "" : 0));

var CardItemInfoRef = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1ybm5lc0"
} : 0)(infoShareStyles, " cursor:pointer;font-size:0.835rem;font-weight:400!important;text-transform:lowercase!important;:hover{text-decoration:underline;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./shared/components/loading-bubbles/index.tsx
var loading_bubbles = __webpack_require__(47364);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/agency.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AgencyStatic;

(function (AgencyStatic) {
  AgencyStatic["AgenciesList"] = "/v2/agencies";
})(AgencyStatic || (AgencyStatic = {}));

var AgencyDynamic = {
  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description get agency details
   */
  AgencyDetail: function AgencyDetail(agencyID) {
    return "/v2/agencies/".concat(agencyID);
  }
};
var agency_endpoint_AgencyEndpoints = _objectSpread(_objectSpread({}, AgencyDynamic), AgencyStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/agencies.request.ts


var getAgencies = function getAgencies(filters) {
  return (0,base_services_request/* getRequest */.A_)(agency_endpoint_AgencyEndpoints.AgenciesList, filters).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
};
var getAgency = function getAgency(id) {
  return getRequest(AgencyEndpoints.AgencyDetail(id)).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  })["catch"](function (error) {
    return error.response;
  });
};
// EXTERNAL MODULE: ./shared/components/messages-result/index.tsx
var messages_result = __webpack_require__(52659);
;// CONCATENATED MODULE: ./shared/components-pages/agencies-agents-list/agency-card-list/index.tsx










var AgencyCardList = function AgencyCardList(props) {
  var search = props.search,
      setCount = props.setCount;

  var request = function request(_ref) {
    var _ref$pageParam = _ref.pageParam,
        pageParam = _ref$pageParam === void 0 ? 1 : _ref$pageParam;
    return getAgencies({
      page: pageParam,
      q: search
    });
  };

  var _useInfiniteQuery = (0,useInfiniteQuery/* useInfiniteQuery */.N)(["listAgencies", search], request, {
    keepPreviousData: false,
    cacheTime: 0,
    getNextPageParam: function getNextPageParam(lastPage, pages) {
      setCount(lastPage.total);

      if (lastPage.last_page == lastPage.current_page) {
        return false;
      }

      return pages.length + 1;
    }
  }),
      data = _useInfiniteQuery.data,
      fetchNextPage = _useInfiniteQuery.fetchNextPage,
      isLoading = _useInfiniteQuery.isLoading,
      hasNextPage = _useInfiniteQuery.hasNextPage,
      isError = _useInfiniteQuery.isError,
      refetch = _useInfiniteQuery.refetch;

  var getMore = function getMore() {
    if (!isLoading && hasNextPage) {
      fetchNextPage();
    }
  };

  (0,react.useEffect)(function () {
    refetch();
  }, [search, props.active]);

  if (isError) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Ha ocurrido un error"
    });
  }

  if (data && (data === null || data === void 0 ? void 0 : data.pages[0].total) == 0 && !isLoading) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Sin resultados"
    });
  }

  if (isLoading) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(loading_bubbles/* default */.Z, null);
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)((react_infinite_scroller_default()), {
    loadMore: getMore,
    hasMore: hasNextPage,
    loader: (0,emotion_react_browser_esm/* jsx */.tZ)(loading_bubbles/* default */.Z, {
      key: 0
    })
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    spacing: 1,
    alignItems: "center",
    justifyContent: "center"
  }, data === null || data === void 0 ? void 0 : data.pages.map(function (page, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, {
      key: i
    }, page.data.map(function (item, j) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
        item: true,
        xl: 4,
        lg: 4,
        md: 4,
        xs: 12,
        key: "".concat(i, "-").concat(j),
        style: {
          padding: '1rem 1.5rem'
        }
      }, (0,emotion_react_browser_esm/* jsx */.tZ)(agency_card, item));
    }));
  })));
};

/* harmony default export */ var agency_card_list = (AgencyCardList);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
;// CONCATENATED MODULE: ./shared/models/enums/refents.enum.ts
var EReferents; // const

(function (EReferents) {
  EReferents["AGENTS"] = "referer";
  EReferents["AGENCY"] = "areferer";
})(EReferents || (EReferents = {}));

var CReferents = (/* unused pure expression or super */ null && (EReferents)); // type
;// CONCATENATED MODULE: ./shared/models/functions/create-refents-query.helper.ts


/**
 * Creates a query string from a configuration object.
 *
 * @param {ICreateReferentsQuery} config - Configuration object.
 * @param {boolean} config.isAgents - Indicates whether it is agents or an agency.
 * @param {number} config.id - ID of the agent or agency.
 * @param {""|"?"|"&"} config.concat - String to concatenate at the beginning of the query string.
 * @return {string} Created query string.
 */
var CreateReferentsQuery = function CreateReferentsQuery(config) {
  // Determine the type of referent (agent or agency) based on the "isAgents" property of the configuration object.
  var TYPEREFERENTS = config.isAgents ? EReferents.AGENTS : EReferents.AGENCY; // Create and return the query string by concatenating the "concat" property of the configuration object, the type of referent, and the ID.

  return "".concat(config.concat).concat(TYPEREFERENTS, "=").concat(config.id);
};
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./shared/components/agent-card/index.tsx


function agent_card_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var Icons = {
  Facebook: "/icons/facebook_icon_gray.svg",
  Twitter: "/icons/x_icon_gray.svg",
  WhatsApp: "/icons/whatsapp_icon_gray.svg",
  Instagram: "/icons/instagram_icon_gray.svg"
};

var AgentCard = function AgentCard(props) {
  var _props$name, _props$name$split$, _props$name2, _props$name2$split$, _ref3, _ref4, _props$mobile2;

  var _useDataLayerEvent = (0,data_layer_event_hook/* default */.Z)(),
      event = _useDataLayerEvent.event;

  var router = (0,next_router.useRouter)();

  var genUrl = function genUrl(red, value) {
    if (red == "WhatsApp") {
      return "https://wa.me/1".concat(value, "?text=Me+interesa+hacer+negorcios");
    } else {
      return value;
    }
  };

  var translation = (0,next_intl_cjs_production_min.useTranslations)("listAgentAgency.list");
  var refer = CreateReferentsQuery({
    concat: "?",
    isAgents: true,
    id: props.id
  });

  var handleClickMobile = function handleClickMobile(phone) {
    window.open("tel:".concat(phone));
    event({
      event_name: "agent_card_phone",
      body: {
        name_agency: props.name,
        phone_agency: phone || props.phone,
        url: router.asPath,
        id_agency: props.id
      }
    });
  };

  var handleClickEmail = function handleClickEmail() {
    window.open("mailto:".concat(props.email));
    event({
      event_name: "agent_card_email",
      body: {
        name_agent: props.name,
        email_agent: props.email,
        url: router.asPath,
        id_agent: props.id
      }
    });
  };

  var clickSeeWhatsApp = function clickSeeWhatsApp(phone) {
    window.open("https://wa.me/1".concat(phone));
    event({
      event_name: "agent_card_whatsapp",
      body: {
        name_agent: props.name,
        phone_agent: phone,
        url: router.asPath,
        id_agent: props.id
      }
    });
  }; // TODO: nothing to do here v2


  return (0,emotion_react_browser_esm/* jsx */.tZ)(Card, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardContentImg, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardImgAgent, {
    src: props.picture,
    alt: props.name
  }, (props === null || props === void 0 ? void 0 : (_props$name = props.name) === null || _props$name === void 0 ? void 0 : (_props$name$split$ = _props$name.split(" ")[0]) === null || _props$name$split$ === void 0 ? void 0 : _props$name$split$.toUpperCase()) + (props === null || props === void 0 ? void 0 : (_props$name2 = props.name) === null || _props$name2 === void 0 ? void 0 : (_props$name2$split$ = _props$name2.split(" ")[1]) === null || _props$name2$split$ === void 0 ? void 0 : _props$name2$split$.toUpperCase()))), (0,emotion_react_browser_esm/* jsx */.tZ)(CardContentInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(LogoAgencyContent, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
    sx: {
      width: "100%",
      height: "100%",
      maxHeight: "70px",
      borderRadius: 1,
      objectFit: "cover"
    },
    src: props.agency_picture,
    alt: props.agency_name
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Divider/* default */.Z, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(AgenteName, null, props.name), (0,emotion_react_browser_esm/* jsx */.tZ)(CarContainerDetail, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CarDetailItem, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ItemLabel, null, translation("phone")), (0,emotion_react_browser_esm/* jsx */.tZ)(ItemRef, {
    style: {
      color: "#676767",
      cursor: "pointer"
    },
    onClick: function onClick() {
      var _ref, _ref2, _props$mobile;

      return handleClickMobile((_ref = (_ref2 = (_props$mobile = props.mobile) !== null && _props$mobile !== void 0 ? _props$mobile : props.phone) !== null && _ref2 !== void 0 ? _ref2 : props.phone2) !== null && _ref !== void 0 ? _ref : "-");
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    style: {
      color: "#676767"
    }
  }, (_ref3 = (_ref4 = (_props$mobile2 = props.mobile) !== null && _props$mobile2 !== void 0 ? _props$mobile2 : props.phone) !== null && _ref4 !== void 0 ? _ref4 : props.phone2) !== null && _ref3 !== void 0 ? _ref3 : "-"))), (0,emotion_react_browser_esm/* jsx */.tZ)(CarDetailItem, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ItemLabel, null, translation("email")), (0,emotion_react_browser_esm/* jsx */.tZ)(ItemRef, {
    onClick: handleClickEmail
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    style: {
      color: "#676767"
    }
  }, props.email))))), (0,emotion_react_browser_esm/* jsx */.tZ)(CardContentFooter, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerBtnFooter, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: props.detailPath,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    className: "--gray"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, translation("seeProfile")))), (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.properties */.K.es.properties + refer,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    className: "--black"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, translation("seeProperties"))))), (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerSocialBtnFooter, null, props.social_networks.map(function (sn, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, sn.name === "WhatsApp" ? (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
      src: Icons[sn.name],
      alt: "".concat(Icons[sn.name], " Icon"),
      width: "30px",
      height: "30px",
      onClick: function onClick() {
        return clickSeeWhatsApp(sn.address);
      },
      style: {
        cursor: "pointer"
      }
    }) : Icons[sn.name] && (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
      href: genUrl(sn.name, sn.address),
      target: "_blank",
      passHref: true,
      key: i
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", null, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
      src: Icons[sn.name],
      alt: "".concat(Icons[sn.name], " Icon"),
      width: "30px",
      height: "30px"
    }))));
  }))));
};

/* harmony default export */ var agent_card = (AgentCard);

var Card = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e41j11i14"
} : 0)( true ? {
  name: "1og6bcw",
  styles: "display:flex;width:100%;height:auto;border-radius:14px;border:1px solid var(--color-brand-grey-senary);overflow:hidden;margin-bottom:15px;flex-direction:row;flex-wrap:wrap"
} : 0);

var CardContentImg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e41j11i13"
} : 0)( true ? {
  name: "10smp9u",
  styles: "display:block;width:40%;height:auto;min-height:250px;& img{height:100%;max-height:250px;object-fit:cover;}@media screen and (max-width: 500px){width:100%;}"
} : 0);

var CardImgAgent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Avatar/* default */.Z,  true ? {
  target: "e41j11i12"
} : 0)( true ? {
  name: "h2d3ac",
  styles: "width:100%;height:100%;border-radius:0px"
} : 0);

var CardContentInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e41j11i11"
} : 0)( true ? {
  name: "k5jym7",
  styles: "display:block;width:60%;height:250px;padding:27px 24px;@media screen and (max-width: 500px){width:100%;height:auto;}"
} : 0);

var LogoAgencyContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e41j11i10"
} : 0)( true ? {
  name: "833hqy",
  styles: "width:200px"
} : 0);

var LogoAgency = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e41j11i9"
} : 0)( true ? {
  name: "osg83x",
  styles: "width:100%;line-height:22px;height:auto;object-fit:cover"
} : 0);

var AgenteName = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h6",  true ? {
  target: "e41j11i8"
} : 0)( true ? {
  name: "1ol0sp5",
  styles: "font-weight:700;font-size:18px;color:var(--color-text-primary);margin:10px 0px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis"
} : 0); //


var CarContainerDetail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e41j11i7"
} : 0)( true ? {
  name: "1cx9wav",
  styles: "width:100%;list-style:none;padding:0.5rem 0"
} : 0);

var CarDetailItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e41j11i6"
} : 0)( true ? {
  name: "19kqexi",
  styles: "display:flex;flex-direction:column;margin-bottom:10px"
} : 0);

var GeneryItemStyles =  true ? {
  name: "176bijj",
  styles: "color:var(--color-brand-grey-main)!important;line-height:20px"
} : 0;

var ItemLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e41j11i5"
} : 0)(GeneryItemStyles, " font-weight:700;font-size:0.9375rem;&::after{content:\":\";}" + ( true ? "" : 0));

var ItemInfo = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "e41j11i4"
} : 0)(GeneryItemStyles, " font-weight:400;font-size:0.875rem;" + ( true ? "" : 0))));

var ItemRef = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e41j11i3"
} : 0)(GeneryItemStyles, " font-weight:500;font-size:0.875rem;cursor:pointer;:hover{text-decoration:underline;}" + ( true ? "" : 0)); //


var CardContentFooter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e41j11i2"
} : 0)( true ? {
  name: "265ik0",
  styles: "display:flex;width:100%;height:120px;background:var(--color-brand-cream-primary);padding:5px 20px;flex-direction:row;@media screen and (max-width: 500px){height:auto;flex-direction:column;}"
} : 0);

var ContainerBtnFooter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e41j11i1"
} : 0)( true ? {
  name: "14geqap",
  styles: "width:45%;display:flex;flex-direction:column;justify-content:space-around;& a{width:100%;max-width:194px;white-space:nowrap;color:white;& span{text-transform:lowercase!important;&:first-letter{text-transform:uppercase!important;}}&.--gray{background:var(--color-brand-red-main);}&.--black{background:#000;}}@media screen and (max-width: 500px){width:100%;margin:auto;display:flex;align-items:center;a{margin:7px 0px;}}"
} : 0);

var ContainerSocialBtnFooter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e41j11i0"
} : 0)( true ? {
  name: "b8cdz2",
  styles: "width:60%;margin:auto;display:flex;align-items:center;& img{margin-right:10px;}@media screen and (max-width: 500px){width:100%;margin:5px auto;justify-content:center;}"
} : 0);
// EXTERNAL MODULE: ./api/agent.request.ts + 1 modules
var agent_request = __webpack_require__(37304);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./shared/components-pages/agencies-agents-list/agent-card-list/index.tsx



function agent_card_list_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function agent_card_list_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? agent_card_list_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : agent_card_list_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var AgentCardList = function AgentCardList(props) {
  var router = (0,next_router.useRouter)();
  var search = props.search,
      setCount = props.setCount,
      _props$isCollection = props.isCollection,
      isCollection = _props$isCollection === void 0 ? false : _props$isCollection,
      active = props.active;

  var _useState = (0,react.useState)([]),
      agents = _useState[0],
      setAgents = _useState[1];

  var request = function request(_ref) {
    var _ref$pageParam = _ref.pageParam,
        pageParam = _ref$pageParam === void 0 ? 1 : _ref$pageParam;

    var filters = agent_card_list_objectSpread({
      page: pageParam,
      q: search,
      collections: isCollection
    }, router.query);

    if (!isCollection) {
      delete filters.collections;
    }

    return (0,agent_request/* getAgents */.j)(filters);
  };

  var _useInfiniteQuery = (0,useInfiniteQuery/* useInfiniteQuery */.N)(["listAgents", isCollection ? "isCollection" : "", search], request, {
    keepPreviousData: false,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    getNextPageParam: function getNextPageParam(lastPage, pages) {
      setCount(lastPage.total);

      if (lastPage.last_page == lastPage.current_page) {
        return false;
      }

      return pages.length + 1;
    },
    onSuccess: function onSuccess(data) {
      GetDataClear(data);
    }
  }),
      data = _useInfiniteQuery.data,
      fetchNextPage = _useInfiniteQuery.fetchNextPage,
      isLoading = _useInfiniteQuery.isLoading,
      hasNextPage = _useInfiniteQuery.hasNextPage,
      isError = _useInfiniteQuery.isError,
      refetch = _useInfiniteQuery.refetch;

  var getMore = function getMore() {
    if (!isLoading && hasNextPage) {
      fetchNextPage();
    }
  };

  var GetDataClear = (0,react.useCallback)(function (data) {
    var values = (0,lodash.uniqBy)(data.pages.map(function (x) {
      return x.data;
    }).flat(100), "id");
    setAgents(values);
  }, [agents]);
  (0,react.useEffect)(function () {
    refetch();
  }, [search, active]);

  if (isError) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Ha ocurrido un error"
    });
  }

  if (data && (data === null || data === void 0 ? void 0 : data.pages[0].total) == 0 && !isLoading) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Sin resultados"
    });
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)((react_infinite_scroller_default()), {
    loadMore: getMore,
    hasMore: hasNextPage,
    loader: (0,emotion_react_browser_esm/* jsx */.tZ)(loading_bubbles/* default */.Z, {
      key: 0
    })
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(GetItems, {
    data: agents,
    isCollection: isCollection
  }));
};

/* harmony default export */ var agent_card_list = (AgentCardList);

var GetItems = function GetItems(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    spacing: 1,
    alignItems: "center",
    justifyContent: "center"
  }, props.data.map(function (item, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xl: 6,
      lg: 6,
      md: 6,
      xs: 11,
      key: item.id
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(agent_card, (0,esm_extends/* default */.Z)({}, item, {
      detailPath: props.isCollection ? pages_path/* CPagesPath.es.collection_agent_detail */.K.es.collection_agent_detail(item) + "?referer=" + item.id : pages_path/* CPagesPath.es.agent_detail */.K.es.agent_detail(item) + "?referer=" + item.id
    })));
  }));
};
;// CONCATENATED MODULE: ./shared/components-pages/agencies-agents-list/List-section/index.tsx


function List_section_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var ListSection = function ListSection(props) {
  var search = props.search,
      setCount = props.setCount,
      _props$isCollection = props.isCollection,
      isCollection = _props$isCollection === void 0 ? false : _props$isCollection,
      active = props.active;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerListSection, null, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "container p-v-20"
  }, props.active == 1 && (0,emotion_react_browser_esm/* jsx */.tZ)(agency_card_list, {
    search: search,
    setCount: setCount,
    active: active
  }), props.active == 2 && (0,emotion_react_browser_esm/* jsx */.tZ)(agent_card_list, {
    isCollection: isCollection,
    search: search,
    setCount: setCount,
    active: active
  })));
};

/* harmony default export */ var List_section = (ListSection);

var ContainerListSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1e4hztg0"
} : 0)( true ? {
  name: "172mwfe",
  styles: "padding-top:20px;width:100%;background-color:var(--color-brand-bg-secondary);& .results_container{display:grid;grid-template:auto/auto auto;gap:30px 10px;}@media screen and (max-width: 991px){& .results_container{grid-template:auto/auto;gap:30px 10px;}}"
} : 0);

/***/ }),

/***/ 54602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





function ResultCounter(props) {
  var active = props.active,
      count = props.count;
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("listAgentAgency.header");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ResultContent, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
    className: "results_counter"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
    className: "container"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("p", {
    className: "results_counter_text"
  }, translation("searchResult", {
    results: count !== null && count !== void 0 ? count : 0
  }), active == 1 ? translation("agencyTitle") : translation("agentTitle")))));
}

/* harmony default export */ __webpack_exports__["Z"] = (ResultCounter);

var ResultContent = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("section",  true ? {
  target: "emutoqp0"
} : 0)( true ? {
  name: "r5kyqd",
  styles: "& .results_counter{width:100%;background-color:#fff;padding:20px 0;margin-bottom:2px;@media screen and (max-width: 576px){padding:0px 0;}}& span{color:var(--color-brand-blue-main);font-weight:600;}& .results_counter_text{text-align:center;font-size:0.938rem;font-weight:500;color:#969daf;margin-bottom:0;}"
} : 0);

/***/ }),

/***/ 74297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57709);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var Search = function Search(props) {
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_4__.useTranslations)("listAgentAgency.header");
  var formik = (0,formik__WEBPACK_IMPORTED_MODULE_1__/* .useFormik */ .TA)({
    initialValues: {
      search: ""
    },
    onSubmit: function onSubmit(e) {
      props.setSearch(e.search);
    }
  });

  var debounce = lodash__WEBPACK_IMPORTED_MODULE_3___default().debounce(function () {
    checkSearch();
  }, 500);

  var checkSearch = function checkSearch() {
    if (formik.values.search.length > 2) {
      formik.submitForm();
    } else if (formik.values.search == "") {
      formik.submitForm();
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    formik.resetForm();
  }, [props.active]);
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(SearchContainer, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
    className: "search_form"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ContainerInput, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CustomInput, {
    className: "search_input",
    type: "text",
    placeholder: props.active == 1 ? translation("agencyPlaceholder") : translation("agentPlaceholder"),
    id: "search_type",
    name: "search",
    onKeyUp: debounce,
    onChange: formik.handleChange,
    value: formik.values.search
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ButtonSubmit, {
    onClick: function onClick() {
      return formik.submitForm();
    }
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
    src: "/icons/search-icon.svg",
    alt: "Loupe icon",
    width: "25px",
    height: "25px"
  }))), formik.values.search.length < 3 && formik.values.search != "" && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(HelpMessage, null, translation("helpMessage"))));
};

/* harmony default export */ __webpack_exports__["Z"] = (Search);

var HelpMessage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eeaanqy4"
} : 0)( true ? {
  name: "hfe91l",
  styles: "width:95%;background-color:white;margin-top:0px;margin-left:20px;color:gray;padding:0px 5px;background:white;padding:13px;position:absolute;border-radius:5px;transition:1s;position:relative;z-index:10;top:-4px;box-shadow:rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
} : 0);

var ContainerInput = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eeaanqy3"
} : 0)( true ? {
  name: "182l30n",
  styles: "display:flex;border-radius:50px;align-items:center;background:white;padding:0px 20px;@media screen and (max-width: 575px){border-radius:10px;}"
} : 0);

var CustomInput = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,  true ? {
  target: "eeaanqy2"
} : 0)( true ? {
  name: "c9lxfx",
  styles: "background:white;padding:13px 0px;border-radius:50px;width:100%;color:var(--color-brand-grey-quaternary);opacity:1;font-size:16px;font-weight:600;color:var(--color-brand-grey-quaternary);input{padding:10px;}input::placeholder{color:var(--color-brand-grey-quaternary);opacity:1;font-size:16px;font-weight:600;}fieldset{border:none;width:100%;}@media screen and (max-width: 575px){border-radius:10px;}"
} : 0);

var ButtonSubmit = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button",  true ? {
  target: "eeaanqy1"
} : 0)( true ? {
  name: "da74p3",
  styles: "background-color:black;border:none;outline:none;padding:14px 20px;border-radius:15px;position:absolute;right:-10px;align-self:center;cursor:pointer;@media screen and (max-width: 575px){width:100%;max-width:76px;}"
} : 0);

var SearchContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eeaanqy0"
} : 0)( true ? {
  name: "10lqcb2",
  styles: "& .search_form{position:relative;max-width:100%;margin:0 auto;}"
} : 0);

/***/ }),

/***/ 66621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36864);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25662);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98456);


var _excluded = ["loadingMessage", "thin_button"];






var Button = function Button(_ref, ref) {
  var _props$bg, _props$fs, _ref2;

  var loadingMessage = _ref.loadingMessage,
      thin_button = _ref.thin_button,
      props = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  var backgroundColor = (props === null || props === void 0 ? void 0 : props.variant) != "text" ? "var(".concat((_props$bg = props === null || props === void 0 ? void 0 : props.bg) !== null && _props$bg !== void 0 ? _props$bg : "--color-brand-red-main", ")") : "transparent";
  var styles = {
    root:
    /*#__PURE__*/

    /*#__PURE__*/
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)({
      boxShadow: "none",
      transition: "0.5s",
      fontFamily: "var(--font-family)",
      fontWeight: 700,
      fontSize: (_props$fs = props.fs) !== null && _props$fs !== void 0 ? _props$fs : 12,
      padding: thin_button ? "0.5rem 2rem" : "10px 35px 10px 35px",
      // @ts-ignore
      color: (_ref2 = "var(".concat(props.colortext, ")")) !== null && _ref2 !== void 0 ? _ref2 : "var(--color-brand-bg-secondary)",
      borderRadius: 28,
      textAlign: "center",
      backgroundColor: backgroundColor,
      ":hover": {
        backgroundColor: backgroundColor,
        opacity: 0.9,
        scale: "1.05",
        transition: "1s"
      }
    },  true ? "" : 0,  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    target: props === null || props === void 0 ? void 0 : props.target,
    variant: "contained",
    css: styles.root
  }, props), loadingMessage !== null && loadingMessage !== void 0 ? loadingMessage : props.children, loadingMessage && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    style: {
      width: 20,
      height: 20,
      color: "red",
      marginLeft: 10
    }
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(Button));

/***/ }),

/***/ 47364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18872);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);


var _excluded = ["message"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





function LoadingBubbles(props) {
  var _props$message = props.message,
      message = _props$message === void 0 ? "Cargando más" : _props$message,
      rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Loading, rest, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
    style: {
      marginRight: 15
    }
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("img", {
    src: "/icons/loading-icon.svg",
    alt: "loading"
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", null, message)));
}

/* harmony default export */ __webpack_exports__["Z"] = (LoadingBubbles);
var spinner = /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)( true ? {
  name: "b7n1on",
  styles: "0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"
} : 0);
var centerStyles = "\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 9999;\n";

var Loading = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e76jmd50"
} : 0)(function (props) {
  return "\n  width: 100%;\n  background-color: \"transparent\";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 15px;\n  font-weight: 600;\n  color:gray;\n   & img {\n    animation: ".concat(spinner, " 2s infinite;\n  }\n  ").concat(props.center ? centerStyles : '', "\n");
},  true ? "" : 0);

/***/ }),

/***/ 52659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ MessageResults; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var MessageResults = function MessageResults(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(MessageContent, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", null, props.message, " ", (props === null || props === void 0 ? void 0 : props.modalComponent) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(props.modalComponent, {})));
};

var MessageContent = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "ef5l1rl0"
} : 0)( true ? {
  name: "11ru1eu",
  styles: "height:calc(100vh - 375px);display:flex;justify-content:center;align-items:center;& span{font-size:19px;font-weight:600;color:var(--color-brand-grey-main);max-width:800px;text-align:center;}"
} : 0);

/***/ }),

/***/ 1283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CPagesPath; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var UniversalLinks = {
  blog: "https://blog.remaxrd.com/"
};
var es = {
  home: "/",
  collection: "/collection",
  collection_properties: "/collection/propiedades",
  collection_agents_list: "/collection/agentes",
  collection_property_detail: function collection_property_detail(x) {
    return "/collection/propiedad/".concat(RealestateEncode(x.realstate_type), "/").concat(x.slug);
  },
  collection_agent_detail: function collection_agent_detail(x) {
    return "/collection/agente/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  properties: "/propiedades",
  shop: "/propiedades/comprar",
  acquire: "/propiedades/alquilar",
  property_detail: function property_detail(x) {
    return "/propiedad/".concat(RealestateEncode(x.realstate_type), "/").concat(x === null || x === void 0 ? void 0 : x.slug);
  },
  project: "/proyectos",
  project_Detail: function project_Detail(x) {
    return "/proyecto/".concat(x.slug);
  },
  loan_form: "/prestamos/formulario",
  loan_mortgage: "/prestamos/hipotecarios",
  loan_calculator: "/prestamos/calculadora",
  franchises: "/franquicias",
  agents_list: "/listado/agentes",
  agent_detail: function agent_detail(x) {
    return "/agente/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  agencies_list: "/listado/agencias",
  agency_detail: function agency_detail(x) {
    return "/agencia/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  frequent_questions: "/preguntas-frecuentes",
  join: "/agentes",
  termsAndCondition: "/terminos-condiciones",
  privacyPolitics: "/politica-privacidad",
  signin: "/acceder",
  profile: "/perfil",
  profileEditar: "/perfil/configuracion/editar-perfil",
  profileCambiarClave: "/perfil/configuracion/cambiar-clave",
  profileFavorites: "/perfil/configuracion/favoritos",
  ProfileSearchHistory: "/perfil/configuracion/busquedas",
  ProfileLastedSee: "/perfil/configuracion/historial-busquedas",
  signup: "/registrate",
  forgotPassword: "/restaurar-clave"
};
var CPagesPath = _objectSpread(_objectSpread({}, UniversalLinks), {}, {
  es: es
});

var HEncodeString = function HEncodeString(x) {
  return "".concat(x.replace(/\//g, "-").split(" ").join("-").toLowerCase());
};

var RealestateEncode = function RealestateEncode(x) {
  var _x$replaceAll;

  return x === null || x === void 0 ? void 0 : (_x$replaceAll = x.replaceAll("/", "o")) === null || _x$replaceAll === void 0 ? void 0 : _x$replaceAll.replaceAll(" ", "-").toLowerCase();
};

/***/ }),

/***/ 72020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bV": function() { return /* binding */ AgencyPicPlaceholder; }
/* harmony export */ });
/* unused harmony exports AgentPicPlaceholder, propertyPicPlaceholder */
var AgencyPicPlaceholder = '/icons/remax-balloon.png';
var AgentPicPlaceholder = '/icons/remax-balloon.png';
var propertyPicPlaceholder = '/icons/remax-balloon.png';

/***/ }),

/***/ 57626:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Creates a canonical URL by removing unnecessary query parameters
 * @param url - The original URL
 * @param keepParams - Optional array of parameter names to keep
 * @returns A clean canonical URL
 */
var prepareUrl = function prepareUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  try {
    // Handle empty or invalid URLs
    if (!url || typeof url !== "string") return ""; // For relative URLs, prepend with origin

    var isRelative = !url.startsWith("http");
    var baseUrl =  true ? window.location.origin : 0;
    var fullUrl = isRelative ? "".concat(baseUrl).concat(url.startsWith("/") ? "" : "/").concat(url) : url; // Parse the URL

    var urlObject = new URL(fullUrl); // If no params to keep, return without query string

    if (!keepParams.length) {
      return "".concat(urlObject.origin).concat(urlObject.pathname);
    } // Create a new URLSearchParams object to manipulate parameters


    var params = new URLSearchParams(); // Only keep specified parameters

    keepParams.forEach(function (param) {
      var value = urlObject.searchParams.get(param);

      if (value) {
        params.set(param, value);
      }
    }); // Build the canonical URL

    var queryString = params.toString();
    return "".concat(urlObject.origin).concat(urlObject.pathname).concat(queryString ? "?".concat(queryString) : "");
  } catch (error) {
    // Fallback method
    try {
      var questionMarkIndex = url.indexOf("?");

      if (questionMarkIndex === -1 || !keepParams.length) {
        // No query params or nothing to keep
        return questionMarkIndex === -1 ? url : url.substring(0, questionMarkIndex);
      } // Manual parsing for fallback


      var base = url.substring(0, questionMarkIndex);
      var query = url.substring(questionMarkIndex + 1);
      var pairs = query.split("&");
      var filteredPairs = pairs.filter(function (pair) {
        var key = pair.split("=")[0];
        return keepParams.includes(key);
      });
      return filteredPairs.length > 0 ? "".concat(base, "?").concat(filteredPairs.join("&")) : base;
    } catch (_unused) {
      return url; // Return original if all else fails
    }
  }
};

var createCanonicalUrl = function createCanonicalUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var urlresolve = prepareUrl(url, keepParams); // console.log(urlresolve);

  return urlresolve;
};

/* harmony default export */ __webpack_exports__["Z"] = (createCanonicalUrl);

/***/ }),

/***/ 84100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ userState; },
/* harmony export */   "N": function() { return /* binding */ getUserToken; }
/* harmony export */ });
function userState() {
  var user = getLocalStorageItem("user");
  var parsedUser = null;

  if (user) {
    try {
      parsedUser = JSON.parse(user);
    } catch (e) {
      console.error("Error parsing user");
    }
  }

  return parsedUser;
}
function getUserToken() {
  var token = getLocalStorageItem("token");
  return token;
}

function getLocalStorageItem(key) {
  var item = null;

  if (true) {
    item = localStorage.getItem(key);
  }

  return item;
}

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);